import { library } from "@fortawesome/fontawesome-svg-core";
import * as Icons from "@fortawesome/free-solid-svg-icons";

import { useIntersectionObserver, useIsClient } from "@uidotdev/usehooks";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SectionContainer, TextStyled } from "../styles";
import {
  BenefitContent,
  BenefitDescription,
  BenefitIconTile,
  BenefitsContainer,
  BenefitsSectionCard,
  BenefitTitle,
  CardStyled,
  FontAwesomeIconStyled,
} from "./styles";

function CompanyBenefits(props) {
  const { companyDetail, setCurrentTab } = props || {};
  const { t } = useTranslation();

  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    rootMargin: "-200px 0px -60% 0px",
  });
  
  useEffect(() => {
    if (entry?.isIntersecting) {
      setCurrentTab(4);
    }
  }, [entry?.isIntersecting, setCurrentTab]);

  const isClient = useIsClient();

  const iconList = Object.keys(Icons)
    .filter((key) => key !== "fas" && key !== "prefix")
    .map((icon) => Icons[icon]);

  library.add(...iconList);

  const replaceIcon = (iconCode) => {
    if (iconCode === "money") {
      iconCode = "money-bill-alt";
    } else if (iconCode === "clock-o") {
      iconCode = "clock";
    }
    return iconCode;
  };

  return (
    <SectionContainer
      aria-label={t("companydetail.benefits_section_aria")}
      id="CompanyBenefits"
      ref={ref}
    >
      <BenefitsSectionCard>
        <TextStyled
          component="h2"
          fontSize="20px"
          fontWeight={700}
          lineHeight="30px"
          textTransform="none"
          aria-label={t("companydetail.benefits_section_title_aria")}
          color="#000"
        >
          {t("companydetail.company_benefits")}
        </TextStyled>
        <BenefitsContainer>
          {companyDetail.map((benefit, index) => {
            return (
              <CardStyled key={index} id="cdp-benefit">
                <BenefitIconTile>
                  {isClient && (benefit.iconCode || benefit.icon_code) ? (
                    <FontAwesomeIconStyled
                      alt={
                        t("companydetail.benefit_icon_alt", {
                          icon: replaceIcon(benefit.iconCode || benefit.icon_code),
                        })
                      }
                      icon={replaceIcon(benefit.iconCode || benefit.icon_code)}
                    />
                  ) : null}
                </BenefitIconTile>
                <BenefitContent>
                  <BenefitTitle>{benefit?.title}</BenefitTitle>
                  <BenefitDescription>{benefit?.description}</BenefitDescription>
                </BenefitContent>
              </CardStyled>
            );
          })}
        </BenefitsContainer>
      </BenefitsSectionCard>
    </SectionContainer>
  );
}

export default CompanyBenefits;
